import accountSVG from "../../images/account.svg";
import EditButton from "../buttons/EditButton";
import DeleteButton from "../buttons/DeleteButton";
import React, {useState} from "react";
import styled from "styled-components";
import AddOrEditLinkModal from "../modal/AddOrEditLinkModal";
import YesNoModal from "../modal/YesNoModal";
import {useDispatch, useSelector} from "react-redux";
import {deleteLink} from "./linksActions";
import {loadProject} from "../project/one-project/projectAction";
import {DisplayForHead} from "../../permissions/DisplayAccordingToRole";
import {getImage} from "../../utils/utils";

const Link = ({id, name, url, author}) => {

    const {id: projectId, pilot, copilot} = useSelector(state => state.project)
    const [isOpenEditModal, setIsOpenEditModal] = useState(false)
    const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false)
    const dispatch = useDispatch()
    const {id: currentUserId} = useSelector(state => state.currentUser)

    const canEdit = currentUserId === pilot.id || copilot?.id === currentUserId || currentUserId === author.id

    const handleDelete = async (id) => {
        await dispatch(deleteLink(id))
        await dispatch(loadProject(projectId))
        setIsOpenDeleteModal(false)
    }

    const displayModal = () => {
        if (isOpenEditModal) {
            return <AddOrEditLinkModal setIsOpen={setIsOpenEditModal} id={id}/>
        }
        if (isOpenDeleteModal) {
            return <YesNoModal
                setOpenModal={setIsOpenDeleteModal}
                name={'ce lien'}
                id={id}
                handleClickYesAction={handleDelete}/>
        }
    }

    const navigate = url => {
        const urlStart = url.slice(0, 4)
        const httpsURL = urlStart === "http" ? url : "https://" + url
        window.open(httpsURL, '_blank', 'noopener, noreferrer')
    }

    return (
        <>
            {displayModal()}
            <Td>
                <div onClick={() => navigate(url)}><LinkTo> {name} </LinkTo></div>
            </Td>
            <Td>
                <div className={"flex-row gap-1 ai-center"}>
                    <IMG src={getImage(author.photo, accountSVG)}
                         alt={author.firstName + " " + author.lastName}/>
                    <p> {author.firstName} {author.lastName}</p>
                </div>
            </Td>
            <Td>
                <div className={"flex-row gap-1"}>
                    <DisplayForHead
                        hasException={canEdit}
                        component={<EditButton setUpdate={setIsOpenEditModal} data={isOpenEditModal}/>}
                    />
                    <DisplayForHead
                        hasException={canEdit}
                        component={<DeleteButton setOpenDeleteModal={setIsOpenDeleteModal}/>}
                    />

                </div>

            </Td>
        </>
    )
}

const Td = styled.td`
  border-top: ${props => props.primary ? "1px solid var(--color-grey-03)" : ""};
  border-bottom: 1px solid var(--color-grey-03);
  height: 2.5rem;
`

const IMG = styled.img`
  height: 2rem;
  width: 2rem;
  border-radius: 50%;
  object-fit: cover;
`

const LinkTo = styled.p`
  border-bottom: 1px solid var(--color-blue);
  color: var(--color-blue);
  width: fit-content;

  &:hover {
    border-bottom: none;
    color: var(--color-blue-06);
    cursor: pointer;

  }
`

export default Link
